<div class="page-content container">
    <div class="page-header">
      <h1 class="page-title text-primary-d2">
        Roles Partidos
        <small class="page-info text-secondary-d2">
          <i class="fa fa-angle-double-right text-80"></i>
          Lista
        </small>
      </h1>
    </div>



    <div class="row">
      <div class="col-12 col-sm-12 col-md-12">
        <div class="bgc-primary-d1 text-white px-3 py-25">
            <div class="row">
            <div class="col-md-6 col-12">
                <span class="text-90">Lista de</span>
                Rol de Partidos
            </div>
            <div class="col-md-6 col-12">
                <div class="columns columns-right btn-group float-right">
                <button *ngIf="aplicacion.puede_crear" title="Nuevo" (click)="crearNuevoRolPartido()" class="btn btn-outline-default btn-smd bgc-white btn-h-light-primary btn-a-outline-primary py-1 bs-print" type="button">
                    <i class="fa fa-plus text-purple-d1"></i>
                </button>
                </div>
            </div>
            </div>
        </div>
        <div class="bootstrap-table bootstrap4">
            <div class="fixed-table-toolbar">
            <div class="row">
                <div class="col-12 col-md-7">
                <div class="row">
                    <div class="col-12 col-md-12">
                    <app-paginator-header [paginator]="this"></app-paginator-header>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-12">
                    <div class="row">
                        <div class="col-md-2 col-sm-12" ><label>Usuarios </label></div>
                        <div class="col-md-3 col-sm-12">
                        <select [compareWith]="compararObjectos" class="form-control" required name="usuario" [(ngModel)]="filter.usuario">
                            <option [ngValue]="usuario" *ngFor="let usuario of filter.usuarios">{{usuario.nombre_usuario}}</option>
                        </select>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                <div class="col-12 col-md-5 p-0">
                <div class="row">
                    <div class="col-12">
                    <button (click)="getSearch(text_search,null)" class="btn btn-xs btn-app btn-primary my-1" type="button" name="fullscreen" aria-label="Fullscreen" title="Buscar">
                        <i class="d-block h-4 fa fa fa-search text-150"></i>
                    </button>&nbsp;
                    </div>
                </div>
                </div>
            </div>
            </div>
            <div class="clearfix"></div>
            <div class="fixed-table-container" style="padding-bottom: 0px;">
            <div class="fixed-table-header" style="display: none;">
                <table></table>
            </div>
            <div id="gallery" class="fixed-table-body">
                <div class="fixed-table-loading table table-bordered table-hover" style="top: 46.6167px;">
                <span class="loading-wrap">
                    <span class="animation-wrap">
                    <span class="animation-dot"></span>
                    </span>
                </span>
                </div>
                <table *ngIf="roles_partidos.length>0" class="table text-dark-m2 text-95 table-bordered table-hover table-striped table-responsive" id="table">
                <thead class="bgc-white text-grey text-uppercase text-80">
                    <tr>
                    <th>N°</th>
                    <th class="center"><a href="javascript:void(0)">Código <span id="codigo" class="sort fa fa-sort icon-only"></span></a></th>
                    <th class="center"><a href="javascript:void(0)">Logo <span id="logo" class="sort fa fa-sort icon-only"></span></a></th>
                    <th class="center"><a href="javascript:void(0)">Campeonato <span id="campeonato" class="sort fa fa-sort icon-only"></span></a></th>
                    <th class="center"><a href="javascript:void(0)">Rol <span id="rol" class="sort fa fa-sort icon-only"></span></a></th>
                    <th class="center"><a href="javascript:void(0)">Actualizado <span id="actualizado" class="sort fa fa-sort icon-only"></span></a></th>
                    <th class="center"><a href="javascript:void(0)">Validez <span id="validez" class="sort fa fa-sort icon-only"></span></a></th>
                    <th style="text-align: center; width: 140px; " data-field="tools">
                        
                    </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let rol_partido of roles_partidos; let i=index;">
                    <td>
                        {{(i+1)+(this.itemsPerPage*(this.currentPage-1))}}
                    </td>
                    <td>
                        {{rol_partido.codigo}}
                    </td>
                    <td>
                        <div class="imagen-campeonato-vista clearfix">
                        <a href="{{rest_server+rol_partido.campeonato.logo}}" title="{{rol_partido.campeonato.nombre}}" data-rel="colorbox">
                            <img width="50" height="50" alt="sin imagen" src="{{rest_server+rol_partido.campeonato.logo}}" />
                        </a>
                    </div>
                    </td>
                    <td>
                        {{rol_partido.campeonato.nombre}}
                    </td>
                    <td>
                        {{rol_partido.rol.nombre}}
                    </td>
                    <td>
                        {{rol_partido.updatedAt | date:'dd/MM/yyyy - HH:mm'}}
                    </td>
                    <td *ngIf="rol_partido.activo"><span class="badge badge-sm badge-success">ACTIVO</span></td>
                    <td *ngIf="!rol_partido.activo"><span class="badge badge-sm badge-danger">ANULADO</span></td>
                    <td style="text-align: center; width: 140px; ">
                        <div class="action-buttons">
                            <a *ngIf="rol_partido.activo" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirCierreCaja(rol_partido)">
                                <i class="fa fa-lock text-105"></i>
                            </a>                        
                        </div>
                    </td>
                    </tr>
                </tbody>
                </table>
            </div>
            <div class="fixed-table-footer">
                <table><thead><tr></tr></thead></table>
            </div>
            </div>
            <div class="fixed-table-pagination">
            <app-paginator-footer *ngIf="roles_partidos.length>0" class="pagination-detail" [paginator]="this"></app-paginator-footer>
            </div>
        </div>
      </div>
    </div>
</div>

<ng-template #modal_registro_caja_mesa let-modal>
    <div class="modal-header card-header">
        <div class="col-6">
            <span class="text-blue text-125">Cierre de Caja</span>
        </div>
        <div class="col-6">
            <button type="button" class="btn btn-primary btn-primary" (click)="guardarRolPartidoCierre()">
                <i class="fa fa-save red2 align-top bigger-125"></i>
            </button>&nbsp;
            <button *ngIf="cierre_caja._id" type="button" class="btn btn-success btn-success" (click)="generarmensajeWhatsapp()">
                <i class="fab fa-whatsapp red2 align-top bigger-125"></i>
            </button>&nbsp;
            <!--<button class="btn btn-warning" data-toggle="modal" data-target="#cameraModal" >
                <i class="fa fa-camera bigger-110 red2"></i>
            </button>&nbsp;
            <button (click)="clickBotonSubir('subir-foto-planilla')" class="fileUpload btn btn-primary" aria-label="Export" type="button" title="Subir foto ci" aria-expanded="false">
                <i class="fa fa-upload text-red fileUpload-button"></i>
                <input id="subir-foto-planilla" style="display:none" type="file" class="form-control" (change)="subirArchivoFotoPlanilla($event)" placeholder="Upload file" accept=".png,.jpg,.jpeg">
            </button>-->
            <button type="button" class="btn btn-primary btn-danger" (click)="modal.dismiss('Cross click')" >
              <i class="fa fa-times red2 align-top bigger-125"></i>
          </button>
        </div>
    </div>
    <div class="modal-body card-body">
        <!--<div class="modal fade" id="cameraModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-nb modal-dialog-centered" role="document"> 
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="myModalLabel">Camara</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <webcam [width]="300" [height]="500" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"></webcam>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" data-dismiss="modal">
                            <i class="fa fa-times red2 text-110 mr-1"></i>
                        </button>
                        <button (click)="capturarImagen()" class="btn btn-warning" data-dismiss="modal">
                            <i class="fa fa-camera bigger-110 red2"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>-->

        <ng-container *ngFor="let partido of cierre_caja.partidos; let i=index;">
            <div class="accordion" id="a{{i}}-{{partido.id}}">
                <div class="card border-0 bgc-green-l5 overflow-visible">
                    <div class="card-header border-0 bgc-transparent mb-0 input-score" id="h-{{partido.equipo_1.id}}">
                        <h2 class="card-title bgc-transparent text-green-d2 brc-green">
                        <a class="d-style btn btn-white bgc-white btn-brc-tp btn-h-outline-green btn-a-outline-green accordion-toggle border-l-3 radius-0 collapsed" href="#c-{{partido.equipo_1.id}}" data-toggle="collapse" aria-expanded="false" aria-controls="c-{{partido.equipo_1.id}}">
                            {{partido.equipo_1.nombre}} 
                            <span class="v-collapsed px-3px radius-round d-inline-block brc-grey-l1 border-1 mr-3 text-center position-rc">
                            <i class="fa fa-angle-down toggle-icon w-2 mx-1px text-90"></i>
                        </span>
                            <span class="v-n-collapsed px-3px radius-round d-inline-block bgc-green mr-3 text-center position-rc">
                            <i class="fa fa-angle-down toggle-icon w-2 mx-1px text-white text-90 pt-1px"></i>
                        </span>
                        </a>
                        </h2>
                        <input only-num [disabled]="partido.w_o_equipo_1.es_wo || partido.w_o_equipo_2.es_wo" type="number" min="0" step="0" class="form-control" name="marcador_1" [(ngModel)]="partido.marcador_equipo_1" [ngClass]="{'brc-danger-m1 border-3':(partido.marcador_equipo_1===null || partido.marcador_equipo_1 < 0)}">
                        <div class="dropdown">
                            <button id="m{{partido.equipo_1.id}}" type="button" class="px-2 btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="sr-only">Toggle Dropdown</span>
                                <span class="position-absolute badge radius-round text-80">{{sumarMarcadorEquipo(partido.equipo_1)}}</span>
                                <i class="fa fa-caret-down"></i>
                            </button>
                            <div class="dropdown-menu bgc-primary" aria-labelledby="m{{partido.equipo_1.id}}">
                                <ng-container *ngFor="let jugador of partido.equipo_1.jugadores | orderBy:'jugador.persona.nombre_completo'">
                                    <span class="dropdown-item p-0 d-inline-block">{{jugador.jugador.persona.nombre_completo}} <input type="number" min="0" step="1" class="form-control float-right" name="marcador_jugador" [(ngModel)]="jugador.jugador.marcador" ></span>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div id="c-{{partido.equipo_1.id}}" class="collapse" aria-labelledby="h-{{partido.equipo_1.id}}" data-parent="a{{i}}-{{partido.equipo_1.id}}">
                        <div class="card-body pt-1 border-l-3 brc-green bgc-green-l5 p-0">
                        <div class="card border-0 shadow-sm radius-0">
                            <div class="card-header bgc-primary-d1">
                                <label class="text-white">¿Dio W.O.? <input (change)="establecerWOEquipo1(partido)" name="switch-field-eq1" class="ace-switch input-lg ace-switch-sino bgc-green-d1" type="checkbox" [(ngModel)]="partido.w_o_equipo_1.es_wo"/></label>
                                <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)" (click)="agregarProductoAdicional(partido.equipo_1,'ponchillos')">
                                    <i class="fas fa-tshirt text-105"></i>
                                </a>
                                <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)" (click)="agregarProductoAdicional(partido.equipo_1,'sin balon')">
                                    <i class="fas fa-futbol text-105"></i>
                                </a>
                                <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)" (click)="agregarProductoAdicional(partido.equipo_1,'sin cintillo')">
                                    <i class="fas fa-tape text-105"></i>
                                </a>
                                <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)" (click)="crearNuevoJugador(partido.equipo_1)">
                                    <i class="fas fa-plus text-105"></i>
                                </a>
                                <div class="dropdown">
                                    <button id="a{{partido.equipo_1.id}}" type="button" class="px-2 btn btn-warning dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <span class="sr-only">Toggle Dropdown</span>
                                        <span class="position-absolute badge radius-round text-80">{{partido.lista_amarillas_equipo_1?partido.lista_amarillas_equipo_1.length:0}}</span>
                                        <i class="fa fa-caret-down"></i>
                                    </button>
                                    <div class="dropdown-menu bgc-warning" aria-labelledby="a{{partido.equipo_1.id}}">
                                        <a class="dropdown-item p-0" href="#" *ngFor="let jugador of partido.equipo_1.jugadores | orderBy:'jugador.persona.nombre_completo'" (click)="agregarTarjetaPago(partido,partido.equipo_1,jugador.jugador,'AMARILLA')">{{jugador.jugador.persona.nombre_completo}}</a>
                                    </div>
                                </div>
                                <div class="dropdown">
                                    <button id="r{{partido.equipo_1.id}}" type="button" class="px-2 btn btn-danger dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <span class="sr-only">Toggle Dropdown</span>
                                        <span class="position-absolute badge radius-round text-80">{{partido.lista_rojas_equipo_1?partido.lista_rojas_equipo_1.length:0}}</span>
                                        <i class="fa fa-caret-down"></i>
                                    </button>
                                    <div class="dropdown-menu bgc-danger" aria-labelledby="r{{partido.equipo_1.id}}">
                                        <a class="dropdown-item p-0 text-white" href="#" *ngFor="let jugador of partido.equipo_1.jugadores | orderBy:'jugador.persona.nombre_completo'" (click)="agregarTarjetaPago(partido,partido.equipo_1,jugador.jugador,'ROJA')">{{jugador.jugador.persona.nombre_completo}}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="card-header bgc-primary-d1" *ngIf="partido.equipo_1.detalles_ventas_pendientes.length>0">
                                <p class="card-title text-white">Pendientes:</p>
                                <select [compareWith]="compararObjectos" class="form-control" required name="usuario" [(ngModel)]="partido.equipo_1.pendiente_seleccionado">
                                    <option class="text-white" [ngClass]="{'bgc-danger':detalle_venta.producto.nombre.includes('ROJA'),'bgc-warning':detalle_venta.producto.nombre.includes('AMARILLA')}" [ngValue]="detalle_venta" *ngFor="let detalle_venta of partido.equipo_1.detalles_ventas_pendientes">{{detalle_venta.venta.fecha | date:'dd/MM/yyyy'}} {{detalle_venta.venta.saldo.toFixed(2)}} {{detalle_venta.producto.nombre}} {{detalle_venta.descripcion}}</option>
                                </select>
                                <button type="button" class="btn btn-success btn-sm" (click)="agregarPendiente(partido.equipo_1,partido.equipo_1.pendiente_seleccionado)">
                                    <i class="ace-icon fa fa-arrow-down bigger-110"></i>
                                </button>
                            </div>
                            <div class="card-body bgc-transparent p-0 border-1 brc-primary-m3 border-t-0">
                            <table class="table table-striped table-hover mb-0 text-danger">
                                <thead class="text-dark-l2 text-95">
                                <tr>
                                    <th>
                                    <i class="far fa-user text-blue mr-1px"></i>
                                    Pago
                                    </th>
                                    <th>
                                    <i class="fa fa-money-bill-alt text-success-d1 mr-1px"></i>
                                    Efectivo
                                    </th>
                                    <th>
                                    <i class="fa fa-qrcode text-black-d1 mr-1px"></i>
                                    QR
                                    </th>
                                    <th style="text-align: center;" data-field="tools">
                                    
                                    </th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr *ngFor="let detalle_pago of partido.equipo_1.detalle_pago; let i=index;">
                                    <td class="text-dark-m2">{{detalle_pago.producto.nombre}} {{detalle_pago.descripcion}} {{detalle_pago.fecha}} </td>
                                    <td class="input-score">
                                        <input (keyup)="sumarIngresos()" style="width: 80px;" type="number" min="0" step="0.001" class="form-control" name="{{i}}-{{partido.equipo_1.id}}" [(ngModel)]="detalle_pago.importe">
                                    </td>
                                    <td class="input-score">
                                        <input (keyup)="sumarIngresos()" style="width: 80px;" type="number" min="0" step="0.001" class="form-control" name="{{i}}-{{partido.equipo_1.id}}" [(ngModel)]="detalle_pago.qr">
                                    </td>
                                    <td class="p-0" style="text-align: center;">
                                    <div class="action-buttons">
                                        <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="eliminarServicio(partido,partido.equipo_1,detalle_pago)">
                                        <i class="fa fa-trash-alt text-105"></i>
                                        </a>
                                    </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            </div><!-- /.card-body -->
                        </div><!-- /.card -->
                        </div>
                    </div>
                </div>

                <div class="card border-0 bgc-green-l5 overflow-visible">
                    <div class="card-header border-0 bgc-transparent mb-0 input-score" id="h-{{partido.equipo_2.id}}">
                        <h2 class="card-title bgc-transparent text-green-d2 brc-green">
                        <a class="d-style btn btn-white bgc-white btn-brc-tp btn-h-outline-green btn-a-outline-green accordion-toggle border-l-3 radius-0 collapsed" href="#c-{{partido.equipo_2.id}}" data-toggle="collapse" aria-expanded="false" aria-controls="c-{{partido.equipo_2.id}}">
                            {{partido.equipo_2.nombre}}
                            <span class="v-collapsed px-3px radius-round d-inline-block brc-grey-l1 border-1 mr-3 text-center position-rc">
                            <i class="fa fa-angle-down toggle-icon w-2 mx-1px text-90"></i>
                        </span>
                            <span class="v-n-collapsed px-3px radius-round d-inline-block bgc-green mr-3 text-center position-rc">
                            <i class="fa fa-angle-down toggle-icon w-2 mx-1px text-white text-90 pt-1px"></i>
                        </span>
                        </a>
                        </h2>
                        <input only-num [disabled]="partido.w_o_equipo_1.es_wo || partido.w_o_equipo_2.es_wo" type="number" min="0" step="0" class="form-control" name="marcador_2" [(ngModel)]="partido.marcador_equipo_2" [ngClass]="{'brc-danger-m1 border-3':(partido.marcador_equipo_2===null || partido.marcador_equipo_2 < 0)}">
                        <div class="dropdown">
                            <button id="m{{partido.equipo_2.id}}" type="button" class="px-2 btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="sr-only">Toggle Dropdown</span>
                                <span class="position-absolute badge radius-round text-80">{{sumarMarcadorEquipo(partido.equipo_2)}}</span>
                                <i class="fa fa-caret-down"></i>
                            </button>
                            <div class="dropdown-menu bgc-primary" aria-labelledby="m{{partido.equipo_2.id}}">
                                <ng-container *ngFor="let jugador of partido.equipo_2.jugadores | orderBy:'jugador.persona.nombre_completo'">
                                    <span class="dropdown-item p-0 d-inline-block">{{jugador.jugador.persona.nombre_completo}} <input type="number" min="0" step="1" class="form-control float-right" name="marcador_jugador" [(ngModel)]="jugador.jugador.marcador" ></span>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div id="c-{{partido.equipo_2.id}}" class="collapse" aria-labelledby="h-{{partido.equipo_2.id}}" data-parent="a{{i}}-{{partido.equipo_2.id}}">
                        <div class="card-body pt-1 border-l-3 brc-green bgc-green-l5 p-0">
                            <div class="card border-0 shadow-sm radius-0">
                                <div class="card-header bgc-primary-d1">
                                    <label class="text-white">¿Dio W.O.? <input (change)="establecerWOEquipo2(partido)" name="switch-field-eq1" class="ace-switch input-lg ace-switch-sino bgc-green-d1" type="checkbox" [(ngModel)]="partido.w_o_equipo_2.es_wo"/></label>
                                    <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)" (click)="agregarProductoAdicional(partido.equipo_2,'ponchillos')">
                                        <i class="fas fa-tshirt text-105"></i>
                                    </a>
                                    <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)" (click)="agregarProductoAdicional(partido.equipo_2,'sin balon')">
                                        <i class="fas fa-futbol text-105"></i>
                                    </a>
                                    <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)" (click)="agregarProductoAdicional(partido.equipo_2,'sin cintillo')">
                                        <i class="fas fa-tape text-105"></i>
                                    </a>
                                    <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)" (click)="crearNuevoJugador(partido.equipo_2)">
                                        <i class="fas fa-plus text-105"></i>
                                    </a>
                                    <div class="dropdown">
                                        <button id="a{{partido.equipo_2.id}}" type="button" class="px-2 btn btn-warning dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <span class="sr-only">Toggle Dropdown</span>
                                            <span class="position-absolute badge radius-round text-80">{{partido.lista_amarillas_equipo_2?partido.lista_amarillas_equipo_2.length:0}}</span>
                                            <i class="fa fa-caret-down"></i>
                                        </button>
                                        <div class="dropdown-menu bgc-warning" aria-labelledby="a{{partido.equipo_2.id}}">
                                            <a class="dropdown-item p-0" href="#" *ngFor="let jugador of partido.equipo_2.jugadores | orderBy:'jugador.persona.nombre_completo'" (click)="agregarTarjetaPago(partido,partido.equipo_2,jugador.jugador,'AMARILLA')">{{jugador.jugador.persona.nombre_completo}}</a>
                                        </div>
                                    </div>
                                    <div class="dropdown">
                                        <button id="r{{partido.equipo_2.id}}" type="button" class="px-2 btn btn-danger dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <span class="sr-only">Toggle Dropdown</span>
                                            <span class="position-absolute badge radius-round text-80">{{partido.lista_rojas_equipo_2?partido.lista_rojas_equipo_2.length:0}}</span>
                                            <i class="fa fa-caret-down"></i>
                                        </button>
                                        <div class="dropdown-menu bgc-danger" aria-labelledby="r{{partido.equipo_2.id}}">
                                            <a class="dropdown-item p-0 text-white" href="#" *ngFor="let jugador of partido.equipo_2.jugadores | orderBy:'jugador.persona.nombre_completo'" (click)="agregarTarjetaPago(partido,partido.equipo_2,jugador.jugador,'ROJA')">{{jugador.jugador.persona.nombre_completo}}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-header bgc-primary-d1" *ngIf="partido.equipo_2.detalles_ventas_pendientes.length>0">
                                    <p class="card-title text-white">Pendientes:</p>
                                    <select [compareWith]="compararObjectos" class="form-control" required name="usuario" [(ngModel)]="partido.equipo_2.pendiente_seleccionado">
                                        <option class="text-white" [ngClass]="{'bgc-danger':detalle_venta.producto.nombre.includes('ROJA'),'bgc-warning':detalle_venta.producto.nombre.includes('AMARILLA')}" [ngValue]="detalle_venta" *ngFor="let detalle_venta of partido.equipo_2.detalles_ventas_pendientes">{{detalle_venta.venta.fecha | date:'dd/MM/yyyy'}} {{detalle_venta.venta.saldo.toFixed(2)}} {{detalle_venta.producto.nombre}} {{detalle_venta.descripcion}}</option>
                                    </select>
                                    <button type="button" class="btn btn-success btn-sm" (click)="agregarPendiente(partido.equipo_2,partido.equipo_2.pendiente_seleccionado)">
                                        <i class="ace-icon fa fa-arrow-down bigger-110"></i>
                                    </button>
                                </div>
                                <div class="card-body bgc-transparent p-0 border-1 brc-primary-m3 border-t-0">
                                    <table class="table table-striped table-hover mb-0 text-danger">
                                        <thead class="text-dark-l2 text-95">
                                        <tr>
                                            <th>
                                            <i class="far fa-user text-blue mr-1px"></i>
                                            Pago
                                            </th>

                                            <th>
                                            <i class="fa fa-money-bill-alt text-success-d1 mr-1px"></i>
                                            Efectivo
                                            </th>
                                            <th>
                                            <i class="fa fa-qrcode text-black-d1 mr-1px"></i>
                                            QR
                                            </th>

                                            <th style="text-align: center;" data-field="tools">
                                            
                                            </th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <tr *ngFor="let detalle_pago of partido.equipo_2.detalle_pago">
                                            <td class="text-dark-m2">{{detalle_pago.producto.nombre}} {{detalle_pago.descripcion}}  {{detalle_pago.fecha}}</td>
                                            <td class="input-score">
                                                <input (keyup)="sumarIngresos()" style="width: 80px;" type="number" min="0" step="0.001" class="form-control" name="{{i}}-{{partido.equipo_2.id}}" [(ngModel)]="detalle_pago.importe">
                                            </td>
                                            <td class="input-score">
                                                <input (keyup)="sumarIngresos()" style="width: 80px;" type="number" min="0" step="0.001" class="form-control" name="{{i}}-{{partido.equipo_2.id}}" [(ngModel)]="detalle_pago.qr">
                                            </td>
                                            <td class="p-0" style="text-align: center;">
                                            <div class="action-buttons">
                                                <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="eliminarServicio(partido,partido.equipo_2,detalle_pago)">
                                                <i class="fa fa-trash-alt text-105"></i>
                                                </a>
                                            </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div><!-- /.card -->
                        </div>
                    </div>
                </div>

                <div class="card border-0 shadow-sm radius-0">
                    <!-- /.card-body -->
                </div><!-- /.card -->
            </div>
        </ng-container>
        <div class="row">
            <div class="col-4">
                <div class="row">
                    <div class="col-sm-12 col-md-12">
                        <h5 class="widget-title text-success">Ingresos</h5>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <label>Ingresos Efectivo</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <span class="badge badge-success text-white badge-lg radius-4 mb-1">Bs. {{cierre_caja.total_ingresos_efectivo}}</span>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <label>Ingresos QR</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <span class="badge badge-success text-white badge-lg radius-4 mb-1">Bs. {{cierre_caja.total_ingresos_qr}}</span>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="row">
                    <div class="col-sm-12 col-md-12">
                        <h5 class="widget-title text-success">Egresos</h5>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <label>Pago Arbitro</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6 input-score">
                        <input only-num class="form-control" (keyup)="sumarEgresos()" [(ngModel)]="cierre_caja.pago_arbitro" min="0" type="number" step="0.001">
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <label>Pago Mesa</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6 input-score">
                        <input only-num class="form-control" (keyup)="sumarEgresos()" [(ngModel)]="cierre_caja.pago_mesa" min="0" type="number" step="0.001">
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <label>Pago Otros</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6 input-score">
                        <input only-num class="form-control" (keyup)="sumarEgresos()" [(ngModel)]="cierre_caja.pago_otros" min="0" type="number" step="0.001">
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <label>Total Egresos</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <span class="badge badge-danger text-white badge-lg radius-4 mb-1">Bs. {{cierre_caja.total_egresos}}</span>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="row">
                    <div class="col-sm-12 col-md-12">
                        <span class="badge badge-danger text-white badge-lg radius-4 mb-1">Saldo Faltante</span>
                    </div>
                    <div class="col-sm-12 col-md-12">
                            <input (keyup)="sumarEgresos()" class="form-control" [(ngModel)]="cierre_caja.saldo_faltante" min="0" type="number" step="0.001">
                    </div>
                    <div class="col-sm-12 col-md-12">
                        <span class="badge badge-success text-white badge-lg radius-4 mb-1">Saldo Sobrante</span>
                    </div>
                    <div class="col-sm-12 col-md-12">
                            <input (keyup)="sumarIngresos()" class="form-control" [(ngModel)]="cierre_caja.saldo_sobrante" min="0" type="number" step="0.001">
                    </div>
                    <div class="col-sm-12 col-md-12">
                        <span class="text-primary">Saldo Final Caja</span>
                    </div>
                    <div class="col-sm-12 col-md-12">
                            <span class="badge mr-2 pos-rel p-2px text-white mt-2 radius-2 overflow-hidden text-180" [ngClass]="{'bgc-success':cierre_caja.saldo_caja>0,'bgc-danger':cierre_caja.saldo_caja<=0}">Bs. {{cierre_caja.saldo_caja}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>